import React, { PureComponent } from "react";

import Slide from "./Slide";

export default class EmbeddedDashboard extends PureComponent {
  render() {
    const {
      embeddedStyle,
      data: { slides }
    } = this.props;

    return slides.length ? (
      <div>
        <Slide
          key={0}
          slide={slides[0]}
          isResponsive={false}
          embeddedStyle={embeddedStyle}
        />
      </div>
    ) : (
      ""
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Dashboard/EmbeddedDashboard.js